import React, { useState } from 'react';
import ProductDetailDescriptionTab from "./ProductDetailDescriptionTab";
import ProductDetailAlternativeTab from "./ProductDetailAlternativeTab";
import ProductDetailDocumentTab from "./ProductDetailDocumentTab";
import useReduxState from "../../../../hooks/useReduxState";
import Helper from "../../../../support/Helper";
import { useProductStore } from 'src/hooks/product';
import ProductCompareMiniSlider from 'src/component/Product/BottomCompareProduct/ProductCompareMiniSlider';
import PDPBestSellingProduct from '../PDPBestSellingProduct';

const ProductDetailTabs = (props) => {
    const [{ alternative_product_count, product_document_count }, { }, { }] = useProductStore();
    const [alt_product_API_call, set_alt_product_API_call] = useReduxState(false, 'alt_product_API_call');
    const [product_document_API_call, set_product_document_API_call] = useReduxState(false, 'product_document_API_call');
    const [data, setData] = useState("#tab1");
    const setActiveTab = (e) => {
        setData(e.currentTarget.attributes.href.value);
    };
    
    return (
        <>
            <div className="product-detail-tab-area">
                {/* Nav tabs */}
                <ul className="bs5 nav nav-tabs dark-tabs nav-justified mob-tabs-row m-t-20">
                    <li className="bs5 nav-item active">
                        <a className="bs5 nav-link text-none" data-toggle="tab" href="#tab1"
                            onClick={(e) => setActiveTab(e)}>Descriptions</a>
                    </li>
                    {
                        alternative_product_count > 0 &&
                        <li className="bs5 nav-item">
                            <a className="bs5 nav-link text-none" data-toggle="tab" href="#tab2"
                                onClick={(e) => {
                                    setActiveTab(e)
                                    set_alt_product_API_call(Helper.UUID())
                                }}>Subs/Alternatives ({alternative_product_count})</a>
                        </li>
                    }
                    {
                        product_document_count > 0 &&
                        <li className="bs5 nav-item">
                            <a className="bs5 nav-link text-none" data-toggle="tab" href="#tab3"
                                onClick={(e) => {
                                    setActiveTab(e)
                                    set_product_document_API_call(Helper.UUID())
                                }}>Documents ({product_document_count})</a>
                        </li>
                    }
                </ul>
                {/* Tab panes */}
                <div className="tab-content px-0 border-0 mob-tab-content pt-3 mt-0">

                    <ProductDetailDescriptionTab activeTab={data} />

                    <ProductDetailAlternativeTab activeTab={data} />

                    <ProductDetailDocumentTab activeTab={data} />
                    <PDPBestSellingProduct />
                    <ProductCompareMiniSlider />
                </div>
            </div>
        </>
    );
}

export default ProductDetailTabs;